import {useState} from "react";
import {toast} from "react-toastify";
import URLS from "../API/Axios/URLS";
import axiosInstance from "../API/Axios/AxiosConfig";
import {is_success} from "../API/Axios/Status";
import {COMMUNITY_COMMENT_ACTIONS} from "../redux/Reducers/CommunityComments";


export default function useReply(){
    const [reply, setReply] = useState({
        count: 0,
        next: null,
        previous: null,
        results: [],
    });
    const [isLoading, setIsLoading] = useState(false);
    const [query, setQuery] = useState({
        page: 1,
        page_size: 5,
    });



    function addReply(commentId, text) {
        let toasts = toast.loading("Adding reply...");
        return new Promise((resolve, reject) => {
            axiosInstance.post(URLS.ReplyAComment, {
                commentId: commentId,
                text: text,
            }).then((res) => {
                if (is_success(res.status)) {
                    toast.update(toasts, {
                        render: "Reply added successfully",
                        type: "success",
                        isLoading: false,
                        autoClose: 2000,
                    })
                    setReply({
                        ...reply,
                        count: reply.count + 1,
                        results: [res.data.data?.comment, ...reply.results],
                    })
                    resolve(res?.data?.data);
                }
            }).catch((err) => {
                if (err.response) {
                    toast.update(toasts, {
                        render: err.response.data.message,
                        type: "error",
                        isLoading: false,
                        autoClose: 2000,
                    })
                }
                reject(err);
            })
        })
    }

    function FetchOldReplies(commentId){
        setIsLoading(true);
        axiosInstance.get(URLS.GetRepliesList, {
            params: {
                id: commentId,
                page: query.page,
                page_size: query.page_size,
            }
        }).then((res) => {
            if (is_success(res.status)) {
                setReply({
                    ...reply,
                    ...res.data,
                    results: [...reply.results, ...res.data?.results],
                })
                setQuery({
                    ...query,
                    page: query.page + 1,
                })
            }
        }).catch((err) => {
            if (err.response) {
                toast.error(err.response.data.message);
            }
        }).finally(() => {
            setIsLoading(false);
        })
    }

    function removeComment(id){
        setReply({
            ...reply,
            count: reply.count - 1,
            results: reply.results.filter((comment) => comment.id !== id),
        })
    }

    function deleteComment(id){
        let toasts = toast.loading("Deleting comment...");
        return new Promise((resolve, reject) => {
            axiosInstance.delete(URLS.DeleteAComment, {
                data: {
                    commentId: id,
                }
            }).then((res) => {
                removeComment(id);
                toast.update(toasts, {
                    render: "Comment deleted successfully",
                    type: "success",
                    isLoading: false,
                    autoClose: 2000,
                });
                resolve(reply.count - 1);

            }).catch((err) => {
                reject(err);
                toast.update(toasts, {
                    render: "Comment failed to delete",
                    type: "error",
                    isLoading: false,
                    autoClose: 2000,
                });
            })
        })
    }

    const actions = {
        addReply,
        FetchOldReplies,
        deleteComment,
    }

    return [reply, isLoading, actions]


}



